var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"PostList"},[(_vm.isLoading)?_c('VLoading'):_vm._e(),_vm._v(" "),_c('transition',{attrs:{"appear":""}},[_c('ul',{staticClass:"PostList_List"},[_c('VPostListItem',{attrs:{"posts":_vm.computedPosts}})],1)])],1)}
var staticRenderFns = []

export { render, staticRenderFns }